import { clientService } from '../../services/client-service';
import {
  changeClientShortInfoFailed,
  changeClientShortInfoSuccess,
  getClientDetailsFailed,
  getClientDetailsSuccess,
  getShortCashBoxListFailed,
  getShortCashBoxListSuccess, getShortInfo,
  getShortInfoFailed,
  getShortInfoSuccess,
} from '../actions/clientShortInfoAction';
import { call, put, takeEvery, spawn } from 'redux-saga/effects';
import { dealService } from '../../services/deals-service';
import { cashBoxService } from '../../services/cashbox-service';
import {
  ACTIVATE_CLIENT_SHORT_INFO_SAGA,
  CHANGE_CLIENT_SHORT_INFO_REQUESTED,
  GET_CLIENT_DETAILS_REQUEST,
  GET_SHORT_CASHBOXES_REQUESTED,
  GET_SHORT_INFO_REQUESTED,
} from '../actions/actionTypes';
import { messages } from '../../helpers/messages';

const getShortInfoRequest = async (clientId) => {
  return await clientService
    .getShortInfo(clientId)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response) {
        let errorData = error.response.data;
        let commonError = messages[0];
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode];
        }
        window.scrollTo(0, 0);
        throw commonError;
      }
    });
};

const getClientCashBoxesRequest = async (clientId) => {
  return await dealService
    .getClientCashBoxes(clientId)
    .then((response) => response.data.cashBoxIds)
    .catch((error) => {
      if (error.response) {
        let errorData = error.response.data;
        let commonError = messages[0];
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode];
        }
        window.scrollTo(0, 0);
        throw commonError;
      }
    });
};

const getShortCashBoxListRequest = async (ids) => {
  return await cashBoxService
    .getShortCashBoxList(ids)
    .then((response) => response.data.cashBoxes)
    .catch((error) => {
      if (error.response) {
        let errorData = error.response.data;
        let commonError = messages[0];
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode];
        }
        window.scrollTo(0, 0);
        throw commonError;
      }
    });
};

const updateClientRequest = async (clientId, data) => {
  return await clientService
    .updateClient(clientId, data)
    .then((response) => response.data.client)
    .catch((error) => {
      if (error.response) {
        let errorData = error.response.data;
        let commonError = messages[0];
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode];
        }
        window.scrollTo(0, 0);
        throw commonError;
      }
    });
}

const getClientDetailsRequest = async clientId => {
  return await clientService.getClientDetails(clientId)
    .then(response => response.data.client)
    .catch((error) => {
      if (error.response) {
        let errorData = error.response.data;
        let commonError = messages[0];
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode];
        }
        window.scrollTo(0, 0);
        throw commonError;
      }
    })
}

function* changeClientInfo({clientId, data}) {
  try {
    const response = yield call(updateClientRequest, clientId, data)
    yield put(changeClientShortInfoSuccess(response))
    yield put(getShortInfo(clientId))
  } catch (error) {
    yield put(changeClientShortInfoFailed(error))
  }
}

function* fetchClientInfoSaga({ clientId }) {
  try {
    const response = yield call(getShortInfoRequest, clientId);
    yield put(getShortInfoSuccess(response));
  } catch (error) {
    yield put(getShortInfoFailed(error));
  }
}

function* getClientDetailsSagaWorker({ clientId }) {
  try{
    const response = yield call(getClientDetailsRequest, clientId);
    yield put(getClientDetailsSuccess(response));
  } catch (error) {
    yield put(getClientDetailsFailed(error))
  }
}

function* fetchClientCashBoxes({ clientId }) {
  try {
    const ids = yield call(getClientCashBoxesRequest, clientId);
    if (ids && ids.length > 0) {
      const cashBoxes = yield call(getShortCashBoxListRequest, ids.join());
      if (cashBoxes && cashBoxes.length > 0) {
        yield put(getShortCashBoxListSuccess(cashBoxes));
      }
    }
  } catch (error) {
    yield put(getShortCashBoxListFailed(error));
  }
}

function* clientShortInfoSagaWorker( clientId ) {
  yield spawn(fetchClientInfoSaga, clientId);
  yield spawn(fetchClientCashBoxes, clientId);
}

function* getClientInfoSaga() {
  yield takeEvery(GET_SHORT_INFO_REQUESTED, fetchClientInfoSaga);
}

function* getClientCashBoxes() {
  yield takeEvery(GET_SHORT_CASHBOXES_REQUESTED, fetchClientCashBoxes);
}

function* clientShortInfoSaga() {

  yield takeEvery(ACTIVATE_CLIENT_SHORT_INFO_SAGA, clientShortInfoSagaWorker);
}

function* changeClientInfoSaga() {
  yield takeEvery(CHANGE_CLIENT_SHORT_INFO_REQUESTED, changeClientInfo)
}

function* getClientDetailsSaga(){
  yield takeEvery(GET_CLIENT_DETAILS_REQUEST, getClientDetailsSagaWorker)
}

export {
  getClientInfoSaga,
  getClientCashBoxes,
  clientShortInfoSaga,
  changeClientInfoSaga,
  getClientDetailsSaga
};
